import { memo } from 'react';
import { ItalianCitizenshipDPVM } from 'mutation/view-models/registration-citizenship';
import { Divider, Grid, useEventCallback } from '@mui/material';
import { DatePicker } from '@mui/lab';
import PmiTextField from 'shell/components/shared/text-field';
import ArticleList from '../shared/article-list';
import { FormikErrors, FormikTouched } from 'formik';
import { ItemVM } from 'shell/view-models/item';
import DocumentActForm from 'shell/components/shared/act';
import { MotArtCitizenship } from 'shell/models/mutation/mot-art-citizenship';

interface OpenLegisProps {
  values?: ItalianCitizenshipDPVM;
  onChange: (
    key: keyof ItalianCitizenshipDPVM,
    value: ItalianCitizenshipDPVM[keyof ItalianCitizenshipDPVM]
  ) => void;
  onChangeValues: (values: ItalianCitizenshipDPVM) => void;
  errors?: FormikErrors<ItalianCitizenshipDPVM>;
  touched?: FormikTouched<ItalianCitizenshipDPVM>;
  idReason: string;
  disabled?: boolean;
}

const ItalianCitizenshipDPComponent = ({
  onChange,
  values,
  errors,
  touched,
  idReason,
  onChangeValues,
  disabled,
}: OpenLegisProps): React.ReactElement => {
  const onChangeArticleList = useEventCallback((value: ItemVM<MotArtCitizenship> | null) => {
    onChange('article', value);
  });

  return (
    <Grid item container spacing={2}>
      <Grid item xs={12} md={5}>
        <DatePicker
          label="Citt. Italiana dal"
          aria-label="Citt. Italiana dal"
          value={values?.dateFrom || null}
          onChange={(date) => {
            onChange('dateFrom', date);
          }}
          renderInput={(params) => (
            <PmiTextField id="dateFrom" {...params} fullWidth helperText="" disabled={disabled} />
          )}
        />
      </Grid>
      <Grid item xs={12} md={5}>
        <DatePicker
          label="DM-DPR-DP del"
          aria-label="DM-DPR-DP del"
          value={values?.dateDPR || null}
          onChange={(date) => {
            onChange('dateDPR', date);
          }}
          renderInput={(params) => (
            <PmiTextField id="dateDPR" {...params} fullWidth helperText="" disabled={disabled} />
          )}
        />
      </Grid>
      <Grid item xs={12} md={8}>
        <ArticleList
          value={values?.article?.id?.toString() || ''}
          onChange={onChangeArticleList}
          idReason={idReason}
          disabled={disabled}
        />
      </Grid>
      <Grid item xs={12}>
        <Divider />
      </Grid>
      <DocumentActForm
        values={values}
        onChange={(key, value) => {
          onChange(key, value);
        }}
        onChanges={(fields) => {
          onChangeValues(fields);
        }}
        errors={errors}
        touched={touched}
        requiredDigital={{
          documentDate: false,
        }}
        disabled={disabled}
      />
    </Grid>
  );
};

ItalianCitizenshipDPComponent.displayName =
  'Form Accordion Registration Citizenship - Italian Citizenship DP component';

const ItalianCitizenshipDP = memo(ItalianCitizenshipDPComponent);

export default ItalianCitizenshipDP;
